import { gql } from 'react-apollo';

export default gql`
  mutation republicOfferRequestInformation($offerId: ID!, $message: String,$investorRepublicId:ID) {
    republicOfferRequestInformation(offerId: $offerId, message: $message,investorRepublicId:$investorRepublicId)
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/republicOfferRequestInformation.js